import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";
import SubHeader from "../../components/SubHeader";
import { MAFIA_ROLES, NEUTRAL_ROLES, TOWN_ROLES } from "../../types/roleEnum";
import ScenarioUtils from "../../utils/scenarioUtils";
import { RoleClassEnum } from "../../types/roleClassEnum";
import './Help.scss';
import { useState } from "react";
import RolePopup from "../../components/RolePopup";

function Help() {
    const navigate = useNavigate();
    const [rolePopupOpen, setRolePopupOpen] = useState(false);
    const [roleName, setRoleName] = useState('');


    const getList = () => {
        return TOWN_ROLES
            .concat(MAFIA_ROLES)
            .concat(NEUTRAL_ROLES);
    }

    const onRoleClick = (e: any) => {
        const role = e.target.value;
        setRoleName(role);
        setRolePopupOpen(true);
    }    

    
    if (rolePopupOpen) {
        return <div className="mafia-container-wrapper">
            <div className="mafia-container">
                <RolePopup role={roleName} onCancel={()=>setRolePopupOpen(false)} exeTarget={null}/>
            </div>
        </div>
    }

    return <div className="mafia-container-wrapper">
        <div className="mafia-content">
            <SubHeader>Help</SubHeader>
            <div className="mafia-role-selector-wrapper mafia-role-selector-wrapper--help">
                <div className="mafia-role-selector" >
                    {
                        getList().map(roleString => {
                            const roleType = ScenarioUtils.CheckRole(roleString);
                            const cl =  roleType === RoleClassEnum.Mafia ? `mafia-button` : roleType === RoleClassEnum.Neutral ? 'neutral-button' : 'town-button';
                            return <div className={`mafia-role-button`}>
                                <button value={roleString} onClick={onRoleClick} className={cl}>{roleString}</button>
                            </div>
                        })
                    }
                </div>
                
            </div>
        </div>

        <Footer>
            <button onClick={() => navigate('/')}>Ok</button>
        </Footer>
    </div>
}

export default Help;
